import React from "react";
import PropTypes from "prop-types";
import Modal from "theme/components/organisms/Modal";
import ProductConfigurationModalContent from "./ProductConfigurationModalContent";

/** @type {React.FunctionComponent<PropTypes.InferProps<propTypes>>} */
const ProductConfigurationModal = ({
  product,
  selectedConfigurableOptions,
  onConfiurationsSelected,
  buttonLabel,
  isOpen,
  onRequestClose,
}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <ProductConfigurationModalContent
        product={product}
        selectedConfigurableOptions={selectedConfigurableOptions}
        onConfiurationsSelected={onConfiurationsSelected}
        buttonLabel={buttonLabel}
      />
    </Modal>
  );
};

const propTypes = {
  product: PropTypes.shape({
    sku: PropTypes.string.isRequired,
  }).isRequired,
  onConfiurationsSelected: PropTypes.func.isRequired,
  selectedConfigurableOptions: PropTypes.object,
  buttonLabel: PropTypes.any.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};
ProductConfigurationModal.propTypes = propTypes;

export default ProductConfigurationModal;
